<cosmos-auth-layout
  [title]="'auth.signup.title' | translate"
  [subtitle]="'auth.signup.subtitle' | translate"
>

  <form [formGroup]="signupForm" (ngSubmit)="onSubmitForm()" novalidate class="signup-form">

    <div class="form-fields">

      <!-- Name -->
      <p-floatlabel variant="on" class="w-full">
        <input pInputText id="signup-name" formControlName="name" class="w-full" (focus)="onFormFieldFocus()" />
        <label for="signup-name">{{ 'auth.signup.name' | translate }}</label>
      </p-floatlabel>
      @if (signupForm.get('name')?.touched && signupForm.get('name')?.errors?.['required']) {
        <small class="field-error">{{ 'auth.signup.name' | translate }} is required.</small>
      }

      <!-- Surname -->
      <p-floatlabel variant="on" class="w-full">
        <input pInputText id="signup-surname" formControlName="surname" class="w-full" />
        <label for="signup-surname">{{ 'auth.signup.surname' | translate }}</label>
      </p-floatlabel>
      @if (signupForm.get('surname')?.touched && signupForm.get('surname')?.errors?.['required']) {
        <small class="field-error">{{ 'auth.signup.surname' | translate }} is required.</small>
      }

      <!-- Email -->
      <p-floatlabel variant="on" class="w-full">
        <input pInputText id="signup-email" type="email" formControlName="email" class="w-full" autocomplete="email" />
        <label for="signup-email">{{ 'auth.signup.email' | translate }}</label>
      </p-floatlabel>
      @if (signupForm.get('email')?.touched && signupForm.get('email')?.errors?.['corporateEmail']) {
        <small class="field-error">{{ 'auth.signup.errorCorporateEmail' | translate }}</small>
      }
      @if (signupForm.get('email')?.touched && signupForm.get('email')?.errors?.['email']) {
        <small class="field-error">{{ 'auth.signup.errorInvalidEmail' | translate }}</small>
      }

      <!-- Password -->
      <p-floatlabel variant="on" class="w-full">
        <p-password inputId="signup-password" formControlName="password" [feedback]="false" [toggleMask]="true" fluid />
        <label for="signup-password">{{ 'auth.signup.password' | translate }}</label>
      </p-floatlabel>
      @if (signupForm.get('password')?.touched && signupForm.get('password')?.errors?.['minlength']) {
        <small class="field-error">{{ 'auth.signup.errorPasswordLength' | translate }}</small>
      }

      <!-- Company Name -->
      <p-floatlabel variant="on" class="w-full">
        <input pInputText id="signup-company" formControlName="companyName" class="w-full" />
        <label for="signup-company">{{ 'auth.signup.companyName' | translate }}</label>
      </p-floatlabel>

      <!-- Job Title -->
      <p-floatlabel variant="on" class="w-full">
        <input pInputText id="signup-jobtitle" formControlName="jobTitle" class="w-full" />
        <label for="signup-jobtitle">{{ 'auth.signup.jobTitle' | translate }}</label>
      </p-floatlabel>

      <!-- Phone: static +34 prefix + 9-digit input -->
      <div class="phone-field">
        <p-inputgroup class="w-full">
          <p-inputgroup-addon>+34</p-inputgroup-addon>
          <input
            pInputText
            id="signup-phone"
            type="tel"
            formControlName="phone"
            [placeholder]="'auth.signup.phone' | translate"
            maxlength="9"
            class="w-full"
          />
        </p-inputgroup>
        @if (signupForm.get('phone')?.touched && signupForm.get('phone')?.errors?.['pattern']) {
          <small class="field-error">{{ 'auth.signup.errorPhone' | translate }}</small>
        }
      </div>

      <!-- Consent: Terms & Conditions -->
      <div class="flex items-start gap-2">
        <p-checkbox formControlName="terms" inputId="signup-terms" [binary]="true" />
        <label for="signup-terms" class="text-sm leading-snug">
          {{ 'auth.signup.acceptTermsBefore' | translate }}
          <a
            href="/assets/terms/terminos-y-condiciones-cosmos-aplicacion.pdf"
            target="_blank"
            rel="noopener"
            class="text-primary font-bold cursor-pointer"
          >{{ 'auth.signup.termsLink' | translate }}</a>{{ 'auth.signup.acceptTermsAfter' | translate }}
        </label>
      </div>
      @if (signupForm.get('terms')?.touched && signupForm.get('terms')?.errors?.['required']) {
        <small class="field-error">{{ 'auth.signup.errorAcceptTerms' | translate }}</small>
      }

      <!-- Consent: technical & marketing communications -->
      <div class="flex items-start gap-2">
        <p-checkbox formControlName="marketingConsent" inputId="signup-marketing" [binary]="true" />
        <label for="signup-marketing" class="text-sm leading-snug">
          {{ 'auth.signup.acceptMarketing' | translate }}
        </label>
      </div>
      @if (signupForm.get('marketingConsent')?.touched && signupForm.get('marketingConsent')?.errors?.['required']) {
        <small class="field-error">{{ 'auth.signup.errorAcceptMarketing' | translate }}</small>
      }

    </div>

    @if (error()) {
      <p-message severity="error" styleClass="w-full">
        {{ error()! }}
      </p-message>
    }

    <div class="form-actions">
      <button
        pButton
        type="submit"
        severity="primary"
        [label]="'auth.signup.submit' | translate"
        [loading]="loading()"
        [disabled]="signupForm.invalid"
        class="w-full"
      ></button>
    </div>

    <div class="form-link">
      <a routerLink="/login">{{ 'auth.signup.alreadyHaveAccount' | translate }}</a>
    </div>

  </form>

</cosmos-auth-layout>
